export const UNIT_SIZE = 10;

// How big a unit is drawn on the canvas, independent of the source art, which
// is authored at 256px so it stays crisp when scaled down.
// Ground truth (bombard_canon_movement.mov): a bombard cannon spans roughly
// 4.5% of the visible field in AoE2, which on this 800px map would be ~36px.
// 96px is a deliberate compromise: much closer to that proportion than the
// full 256px art, while keeping the detail legible. Change this one value to
// scale units; the shadow, selection ring and pick radius all derive from it.
export const UNIT_DRAW_SIZE = 96;
